import ScheduledNotifications from "../../../views/DriverNotification/ScheduledNotifications/index.js";
import CampaignDetails from "../../../views/DriverNotification/CampaignDetails/index.js";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import NewCampaign from "../../../views/DriverNotification/NewCampaign/index.js";

const DriverNotificationRoutes = [
  {
    menuName: MenuNames.DRIVER_NOTIFICATION,
    path: "/notification_campaigns",
    component: ScheduledNotifications,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_NOTIFICATION,
    path: "/notification_campaigns/:id",
    component: CampaignDetails,
    exact: true,
  },
  {
    menuName: MenuNames.DRIVER_NOTIFICATION,
    path: "/notification_campaign/create_campaign",
    component: NewCampaign,
    exact: true,
  },
];

export default DriverNotificationRoutes;
